import React from 'react';
import { FiArrowRight, FiAward, FiFileText, FiHeadphones, FiLayers } from 'react-icons/fi';
import FeatureCard from './FeatureCard';

type FeaturesProps = {
  className?: string;
};

export default function Features({ className = '' }: FeaturesProps) {
  return (
    <section className={`px-4 py-10 sm:px-6 lg:px-8 lg:py-14 ${className}`}>
      <div className="mx-auto max-w-7xl">
        <div className="rounded-[36px] border border-[var(--line-soft)] bg-white/72 p-6 shadow-[0_24px_60px_-42px_rgba(8,31,53,0.35)] backdrop-blur-xl sm:p-8 lg:p-10">
          <div className="mx-auto max-w-3xl text-center">
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[var(--brand-accent)]">Why choose us</p>
            <h2 className="mt-3 text-2xl font-bold text-[var(--brand-ink)] sm:text-3xl">Everything you need to manage your subscription in one place.</h2>
            <p className="mt-4 text-sm leading-7 text-[var(--text-muted)]">
              learnsocialaicare.com offers you a simple way to manage subscriptions, contact agents, and access support from partner-trained teams.
            </p>
            <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-[var(--line-soft)] bg-[var(--surface-0)] px-4 py-2 text-sm font-semibold text-[var(--brand-accent)]">
              Reliable service <FiArrowRight className="h-4 w-4" aria-hidden="true" focusable="false" />
            </div>
          </div>

          <div className="mt-8 grid gap-6 md:grid-cols-2">
            <FeatureCard title="Simplified management of your subscriptions" icon={<FiLayers />} eyebrow="Management">
              learnsocialaicare.com offers you to easily manage different subscriptions. Fill in the e-mail address you used when you subscribed and reach your customer account in one click.
            </FeatureCard>

            <FeatureCard title="All the essential information" icon={<FiFileText />} eyebrow="Control">
              All the essential information is there to give you maximum control of your subscriptions. You can also contact the agents to ask for help, unsubscribe or make a complaint.
            </FeatureCard>

            <FeatureCard title="Agents at your service" icon={<FiHeadphones />} eyebrow="Support">
              Our agents are experts in after-sales services and have all the answers to your questions. We work 7 days per week, so you can contact the agents by live chat or by phone.
            </FeatureCard>

            <FeatureCard title="Recognized expertise" icon={<FiAward />} eyebrow="Expertise">
              We provide the after-sales service of several partner sites, which are all satisfied with our services. Our expertise provides the support for every single client.
            </FeatureCard>
          </div>
        </div>
      </div>
    </section>
  );
}
